import { REST_METHOD, REST_URL } from 'constants/index';
import { OffBoardingPayload } from 'models';
import { requestEmployeeBoarding } from './api';

type GetListEmployeeParams = {
  manager_email?: string;
  page?: number;
  page_size?: number;
};

type UpdateEmployeePayload = {
  manager_email?: string;
  last_working_date?: string;
  last_access_date?: string;
};

const OffBoardingService = {
  getListEmployee: async (params: GetListEmployeeParams) => {
    const requestParams = {
      url: params.manager_email
        ? REST_URL.OFFBOARDINGS_BY_MANAGER
        : REST_URL.OFFBOARDINGS,
      method: REST_METHOD.GET,
      queryParams: params,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  getTasksDefinition: async () => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDING}${REST_URL.TASK_DEFINITIONS}`,
      method: REST_METHOD.GET,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  addEmployee: async (payload: OffBoardingPayload) => {
    const requestParams = {
      url: REST_URL.OFFBOARDINGS,
      method: REST_METHOD.POST,
      data: payload,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  getOffboardingStatus: async (email: string) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDINGS}/${email}`,
      method: REST_METHOD.GET,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  deleteEmployee: async (userId: string) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDINGS}/${userId}`,
      method: REST_METHOD.DELETE,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  updateEmployee: async (userId: string, payload: UpdateEmployeePayload) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDINGS}/${userId}`,
      method: REST_METHOD.PUT,
      data: payload,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  updateEmployeeTasks: async (
    payload: Array<{ id: string; status: string }>,
  ) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDING}${REST_URL.TASKS}`,
      method: REST_METHOD.PUT,
      data: payload,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  updateOffboardingTasksList: async (userId: string , payload: any[]) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDINGS}/${userId}/${REST_URL.TASKS}`,
      method: REST_METHOD.PUT,
      data: payload,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  },
  getRequireOffBoarding: async (email: string) => {
    const requestParams = {
      url: `${REST_URL.OFFBOARDINGS}/${email}${REST_URL.REQUIRED_TASKS}`,
      method: REST_METHOD.GET,
    };
    const res = await requestEmployeeBoarding(requestParams);
    return res.data;
  }
};

export default OffBoardingService;
